// 预参与态主卡（0519-二次选择）切图常量。结构同 on-progress(组件优化_4)，
// 复用 explore-progress-v4 已上传的美团 CDN，不重复上传。
export const PRE_JOINED_ASSET = {
    /** 头部「更换城市 ›」右箭头 */
    RULE_ARROW: 'https://img.meituan.net/makerjiulv/b2b755bdbc52d51f69a4c24206552730667.png',
    /** 进度+操作面板底图（圆角+顶部尖角） */
    PANEL_BG: 'https://img.meituan.net/makerjiulv/073a7d9e07e3c1a262055c156b5d605914472.png',
    /** 手举¥288 角标 */
    HAND_BADGE: 'https://img.meituan.net/makerjiulv/914a23ccd7a0cfeeb1ae23f3555530d125627.png',
    /** 热门游玩灵感 分隔标题 */
    LANDMARK_HEADER: 'https://img.meituan.net/makerjiulv/291aa20cd960972aab099f90ada1d3674601.png'
};
